import {
  faBell,
  faCalendarCheck,
  faChartPie,
  faUserInjured
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState } from "react";
import {
  BrowserRouter as Router,
  Link,
  Route,
  Switch,
  useHistory
} from "react-router-dom";
import { UserContext } from "../../../App";
import cancelBtn from "../../../images/cancelMenu.svg";
import leftArrow from "../../../images/leftArrow.svg";
import menuBtn from "../../../images/menu.svg";
import DoctorAppointments from "../DoctorAppointments/DoctorAppointments";
import DoctorDashboardData from "../DoctorDashboardData/DoctorDashboardData";
import DoctorSchedule from "../DoctorSchedule/DoctorSchedule";
import "./DoctorDashboard.scss";

const DoctorDashboard = () => {
  const [expandDoctorSidebar, setExpandDoctorSidebar] = useState(false);
  const [loggedInUser] = useContext(UserContext);
  const history = useHistory();

  return (
    <Router>
      <div className="d-flex position-relative">
        {/* Dashboard sidBar Start */}
        <div
          className={`doctorSideBar minDoctorSideBar min-vh-100 ${
            expandDoctorSidebar && "doctorSideBarHide"
          }`}
        >
          <div className="text-end mb-2 sidebarCancelBtn">
            <button
              onClick={() => setExpandDoctorSidebar(!expandDoctorSidebar)}
              className="btn menuBtn"
            >
              <img src={leftArrow} alt="menu button" />
            </button>
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => history.push("/home")}
            className="dashboardLogo"
          >
            <img src="https://i.ibb.co/FzBKrr8/dcLogoWH.png" alt="logo" />
          </div>
          <div className="sidebarMenu">
            <Link to="/doctorDashboard/dashboard">
              <FontAwesomeIcon className="me-3" icon={faChartPie} />
              Dashboard
            </Link>
            <Link to="/doctorDashboard/appointments">
              <FontAwesomeIcon className="me-3" icon={faUserInjured} />
              Appointments
            </Link>
            <Link to="/doctorDashboard/schedule">
              <FontAwesomeIcon className="me-3" icon={faCalendarCheck} />
              Schedule
            </Link>
          </div>
        </div>
        {/* Dashboard sidBar End */}
        {/* Dashboard Child start */}
        <div className="w-100">
          {/* Dashboard TopBar Start */}
          <div>
            <div className="dashboardTopbar">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <button
                    onClick={() => setExpandDoctorSidebar(!expandDoctorSidebar)}
                    className="btn menuBtn"
                  >
                    {expandDoctorSidebar ? (
                      <img src={cancelBtn} alt="menu button" />
                    ) : (
                      <img src={menuBtn} alt="menu button" />
                    )}
                  </button>
                </div>
                <div className="dashboardTopbarMenu d-flex align-items-center">
                  <FontAwesomeIcon className="topbarIcon" icon={faBell} />
                  <div className="profileLogo rounded-circle">
                    <span>{loggedInUser.email[0]}</span>
                  </div>
                  <h4>{loggedInUser.email}</h4>
                </div>
              </div>
            </div>
            <hr className="m-0" />
          </div>
          {/* Dashboard TopBar End */}

          <Switch>
            <Route path="/doctordashboard/dashboard">
              <DoctorDashboardData />
            </Route>
            <Route path="/doctordashboard/schedule">
              <DoctorSchedule />
            </Route>
            <Route path="/doctordashboard/appointments">
              <DoctorAppointments />
            </Route>
          </Switch>
        </div>
        {/* Dashboard Child end */}
      </div>
    </Router>
  );
};

export default DoctorDashboard;
